import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const canSeeColumns = (intl = null, es = false) => [
  {
    className: "companyName",
    dataIndex: "companyName",
    key: "companyName"
  },
  {
    title: intl?.formatMessage({id: "permissions.Nella sua home"}) || "Nella sua home",
    children: [
      // {
      // 	className: "dataColumn",
      // 	title: "Riepilogo fatturato",
      // 	dataIndex: "fatturato",
      // 	key: "fatturato",
      // 	render:fatturato => fatturato === true ?  <FontAwesomeIcon
      // 		icon={["fas", "check-circle"]}
      // 		style={{
      // 				color: "#09822a",
      // 				fontSize: "14px"
      // 		}}/> :  <FontAwesomeIcon
      // 		icon={["fas", "minus-circle"]}
      // 		style={{
      // 				color: "#d82829",
      // 				fontSize: "14px"
      // 		}}/>
      // },
      {
        className: "dataColumn",
        title: intl?.formatMessage({id: "permissions.Riepilogo costi"}) || "Riepilogo costi",
        dataIndex: "costi",
        key: "costi",
        render: (costi) =>
          costi === true ? (
            <FontAwesomeIcon
              icon={["fas", "check-circle"]}
              style={{
                color: "#09822a",
                fontSize: "14px"
              }}
            />
          ) : (
            <FontAwesomeIcon
              icon={["fas", "minus-circle"]}
              style={{
                color: "#d82829",
                fontSize: "14px"
              }}
            />
          )
      },
      {
        className: "dataColumn",
        title: intl?.formatMessage({id: "permissions.Business Performance"}) || "Business Performance",
        dataIndex: "business",
        key: "business",
        render: (business) =>
          business === true ? (
            <FontAwesomeIcon
              icon={["fas", "check-circle"]}
              style={{
                color: "#09822a",
                fontSize: "14px"
              }}
            />
          ) : (
            <FontAwesomeIcon
              icon={["fas", "minus-circle"]}
              style={{
                color: "#d82829",
                fontSize: "14px"
              }}
            />
          )
      },
      {
        className: "dataColumn",
        title: intl?.formatMessage({id: "permissions.Checkup Impresa"}) || "Checkup Impresa",
        dataIndex: "checkup",
        key: "checkup",
        render: (checkup) =>
          checkup === true ? (
            <FontAwesomeIcon
              icon={["fas", "check-circle"]}
              style={{
                color: "#09822a",
                fontSize: "14px"
              }}
            />
          ) : (
            <FontAwesomeIcon
              icon={["fas", "minus-circle"]}
              style={{
                color: "#d82829",
                fontSize: "14px"
              }}
            />
          )
      },
      {
        className: "dataColumn",
        title: intl?.formatMessage({id: "permissions.Incassa subito"}) || "Incassa Subito",
        dataIndex: "incassaSubito",
        key: "incassaSubito",
        render: (incassaSubito) =>
          incassaSubito === true ? (
            <FontAwesomeIcon
              icon={["fas", "check-circle"]}
              style={{
                color: "#09822a",
                fontSize: "14px"
              }}
            />
          ) : (
            <FontAwesomeIcon
              icon={["fas", "minus-circle"]}
              style={{
                color: "#d82829",
                fontSize: "14px"
              }}
            />
          )
      },
      {
        className: "dataColumn",
        title: intl?.formatMessage({id: "permissions.Volume d'affari"}) || "Volume d'affari",
        dataIndex: "FatturatoFiscaleTotale",
        key: "volumeAffari",
        render: (volumeAffari) =>
          volumeAffari === true ? (
            <FontAwesomeIcon
              icon={["fas", "check-circle"]}
              style={{
                color: "#09822a",
                fontSize: "14px"
              }}
            />
          ) : (
            <FontAwesomeIcon
              icon={["fas", "minus-circle"]}
              style={{
                color: "#d82829",
                fontSize: "14px"
              }}
            />
          )
      },
      {
        className: "dataColumn",
        title: intl?.formatMessage({id: "permissions.Riepilogo imposte"}) || "Riepilogo imposte",
        dataIndex: "imposte",
        key: "imposte",
        render: (imposte) =>
          imposte === true ? (
            <FontAwesomeIcon
              icon={["fas", "check-circle"]}
              style={{
                color: "#09822a",
                fontSize: "14px"
              }}
            />
          ) : (
            <FontAwesomeIcon
              icon={["fas", "minus-circle"]}
              style={{
                color: "#d82829",
                fontSize: "14px"
              }}
            />
          )
      }
    ]
  },
  {
    title: intl?.formatMessage({id: "permissions.Nel suo menu"}) ||  "Nel suo menu",
    className: "can-see-menu-column",
    children: [
      {},
      {},
      !es ? {
        className: "dataColumn",
        title: intl?.formatMessage({id: "permissions.Scadenze"}) || "Scadenze",
        dataIndex: "Menu Scadenze",
        key: "menuScadenze",
        render: (menuScadenze) =>
          menuScadenze === true ? (
            <FontAwesomeIcon
              icon={["fas", "check-circle"]}
              style={{
                color: "#09822a",
                fontSize: "14px"
              }}
            />
          ) : (
            <FontAwesomeIcon
              icon={["fas", "minus-circle"]}
              style={{
                color: "#d82829",
                fontSize: "14px"
              }}
            />
          )
      } : {},
      {
        className: "dataColumn",
        title: intl?.formatMessage({id: "permissions.Richieste"}) || "Richieste",
        dataIndex: "Menu Richieste",
        key: "menuRichieste",
        render: (menuRichieste) =>
          menuRichieste === true ? (
            <FontAwesomeIcon
              icon={["fas", "check-circle"]}
              style={{
                color: "#09822a",
                fontSize: "14px"
              }}
            />
          ) : (
            <FontAwesomeIcon
              icon={["fas", "minus-circle"]}
              style={{
                color: "#d82829",
                fontSize: "14px"
              }}
            />
          )
      },
      {
        className: "dataColumn",
        title: intl?.formatMessage({id: "permissions.Fascicoli"}) || "Fascicoli",
        dataIndex: "MenuFascicoliItem",
        key: "menuFascicoli",
        render: (menuFascicoli) =>
          menuFascicoli === true ? (
            <FontAwesomeIcon
              icon={["fas", "check-circle"]}
              style={{
                color: "#09822a",
                fontSize: "14px"
              }}
            />
          ) : (
            <FontAwesomeIcon
              icon={["fas", "minus-circle"]}
              style={{
                color: "#d82829",
                fontSize: "14px"
              }}
            />
          )
      }
    ]
  },
  {
    title: intl?.formatMessage({id: "permissions.Nei suoi documenti"}) || "Nei suoi documenti",
    children: [
      {},
      {},
      {
        className: "dataColumn",
        title: intl?.formatMessage({id: "permissions.Fatture"}) || "Fatture",
        dataIndex: "Invoice",
        key: "Invoice",
        render: (Invoice) =>
          Invoice === true ? (
            <FontAwesomeIcon
              icon={["fas", "check-circle"]}
              style={{
                color: "#09822a",
                fontSize: "14px"
              }}
            />
          ) : (
            <FontAwesomeIcon
              icon={["fas", "minus-circle"]}
              style={{
                color: "#d82829",
                fontSize: "14px"
              }}
            />
          )
      },
      {
        className: "dataColumn",
        title: intl?.formatMessage({id: "permissions.Fiscale"}) || "Fiscale",
        dataIndex: "Fiscal",
        key: "Fiscal",
        render: (Fiscal) =>
          Fiscal === true ? (
            <FontAwesomeIcon
              icon={["fas", "check-circle"]}
              style={{
                color: "#09822a",
                fontSize: "14px"
              }}
            />
          ) : (
            <FontAwesomeIcon
              icon={["fas", "minus-circle"]}
              style={{
                color: "#d82829",
                fontSize: "14px"
              }}
            />
          )
      },
      // {
      // 	className: "dataColumn",
      // 	title: "Società",
      // 	dataIndex: "Company",
      // 	key: "Company",
      // 	render: Company => Company === true ?  <FontAwesomeIcon
      // 			icon={["fas", "check-circle"]}
      // 			style={{
      // 					color: "#09822a",
      // 					fontSize: "14px"
      // 			}}/> :  <FontAwesomeIcon
      // 			icon={["fas", "minus-circle"]}
      // 			style={{
      // 					color: "#d82829",
      // 					fontSize: "14px"
      // 			}}/>
      // },
      {
        className: "dataColumn",
        title: intl?.formatMessage({id: "permissions.Gestione del personale"}) || "Gestione del Personale",
        dataIndex: "HR",
        key: "HR",
        render: (HR) =>
          HR === true ? (
            <FontAwesomeIcon
              icon={["fas", "check-circle"]}
              style={{
                color: "#09822a",
                fontSize: "14px"
              }}
            />
          ) : (
            <FontAwesomeIcon
              icon={["fas", "minus-circle"]}
              style={{
                color: "#d82829",
                fontSize: "14px"
              }}
            />
          )
      },
      {
        className: "dataColumn",
        title: intl?.formatMessage({id: "permissions.Altri"}) || "Altri",
        dataIndex: "Other",
        key: "Other",
        render: (Other) =>
          Other === true ? (
            <FontAwesomeIcon
              icon={["fas", "check-circle"]}
              style={{
                color: "#09822a",
                fontSize: "14px"
              }}
            />
          ) : (
            <FontAwesomeIcon
              icon={["fas", "minus-circle"]}
              style={{
                color: "#d82829",
                fontSize: "14px"
              }}
            />
          )
      }
    ]
  }
];
